import React, { Component } from 'react';
import Radium from 'radium';
import Confetti from 'react-confetti'

import Task from "./Task";
import UserServices from '../services/UserServices';
const MAX_TASKS_PER_DAY = 3;

class TasksView extends Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			editorStates: {},
		};
	}	

	getNumberOfTasksForDay() {
		var count = 0;

		for (var i = 0; i < this.props.tasks.length; i++) {
			if (this.props.tasks[i].id) {
				count ++;
			}
		}

		return count;
	}

	currentDayCompleted() {
		if (this.getNumberOfTasksForDay() === 0) { 
			return false;
		}

		const tasks = this.getTasks();

		
		for (const task of tasks) {
			if (!task || (task.task.id && !task.task.completed)) {
				return false;
			}
		}

		return true;
	}

	renderConfetti() {
		if (!UserServices.getPreference(UserServices.CONFETTI_ON_PREFERENCE)) {
			return null;
		}

		if (!this.currentDayCompleted() || !this.props.completionChanges) {
			return null;
		}

		var confettiSource = {
			x: 0,
			y: 0,
			w: window.innerWidth,
			h: window.innerHeight
		};

		return (
			<Confetti
				recycle={false}	
				numberOfPieces={280}
				confettiSource={confettiSource}
			/>
		)
	}

	onShowTaskMenu(task, evt) {
		this.props.onShowTaskMenu(task, evt);
	}

	getTasks() {
		var tasksToShow = [];

		if (this.props.tasks) {
			this.props.tasks.forEach((task) => {
				tasksToShow.push({
					task: task,
				});
			})
		}

		if (tasksToShow.length < MAX_TASKS_PER_DAY) {
			// Add one more new task editor
			tasksToShow.push({
				task: {
					temp_id: this.props.tempId,
					bubble_id: this.props.selectedBubble ? this.props.selectedBubble.id : undefined,
					title: ""
				}
			});
		}

		return tasksToShow;
	}

	async onEditorStateChange(task, editorState) {
		var idToUse;

		if (task.task.temp_id) {
			idToUse = task.task.temp_id;
		} else {
			idToUse = task.task.id
		}

		var editorStates = this.state.editorStates;
		editorStates[idToUse] = editorState;

		await this.props.onChangeTask(task, task.task.title);

		await this.setState({
			editorStates: editorStates
		});

	}

	render() {
		if (this.props.loading || !this.props.tasks) {
			return null;
		}

		return (
			<div style={localStyles.container}>
				<div style={localStyles.content}>
					<div style={localStyles.innerContent}>
						{this.getTasks().map((task, index) => {
							if (index > 0 && !this.props.tasks[index - 1].id) {
								return null;
							}

							var key = task.task.temp_id || task.task.id;

							return (
								<Task 
									//ref={this[`task${index}`]}
									key={key} 
									keyTest={key} 
									task={task} 
									style={this.props.style}
									date={this.props.date}
									selectedBubble={this.props.selectedBubble}
									selectedTaskMenu={this.props.selectedTaskMenu}
									onTick={() => this.props.onToggleTaskCompletion(task.task)}
									onChange={(title) => this.onChangeTask(index, task, title)}
									onShowTaskMenu={(task, evt) => this.onShowTaskMenu(task, evt)}
									onEditorStateChange={(task) => this.onEditorStateChange(task)}
									/>
							);
						})}
					</div>
					
				</div>
				{this.renderConfetti()}
			</div>
		);
	}
}

const fadeInKeyframes = Radium.keyframes({
	"0%": {opacity: 0},
	"100%": {opacity: 1}
}, 'fadeIn');

const localStyles = {
	container: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		minWidth: 280,
		maxWidth: 600,
		opacity: 1,
		animation: 'opacity 0.15s ease-in-out 0s',
		animationName: fadeInKeyframes,
	},
	content: {
		display: "flex",
		marginTop: 40,
		alignItems: "center",
		flexDirection: "column",
		width: "100%"
	},
	innerContent: {
		width: "80%"
	}
};

export default Radium(TasksView);


// WEBPACK FOOTER //
// ./src/components/TasksView.js